module.exports = __webpack_public_path__ + "img/forward-email.dcd599ef.png";